import React from 'react'
import { ErrorIconFees } from '../../../assets'

const WarningFeeMinimums = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ height: '35px', width: '47px', padding: '0 0 0 10px' }}>
          <img
            src={ErrorIconFees}
            alt=""
            style={{ width: '100%', height: '100%', paddingTop: '-8px' }}
          />
        </div>
        <div style={{ paddingLeft: '18px' }}>
          <p
            style={{
              margin: '0',
              color: '#000',
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '16px',
            }}
          >
            <b>
              Using "ACH Fee," "BLAZEPAY Fee," "Cashless ATM Fee," "Credit Card Fee," or "Stronghold
              Fee" nomenclature may be noncompliant with federal, state, or local law.
            </b>
          </p>
          <p
            style={{
              margin: '0',
              color: '#000',
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '16px',
            }}
          >
            <b>Please consult with your legal professional for guidance.</b>
          </p>
        </div>
      </div>
    </div>
  )
}

export default WarningFeeMinimums



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/WarningFeeMinimums.js